module.exports = __webpack_public_path__ + "static/fowf-mike-color-364c3b7af197a8e63d8ad4e9f691a1e8.jpg";